import React, { Component } from 'react';
import CreditCardLogo from '../../assets/images/credit_card_logos.gif';
import MaskInput from 'react-input-mask';

class CreditCardInfo extends Component {

    onChange = (e) => {
        this.props.onChange(e);
    }

    maskChange = (e) => {
        
    }

    render() {

        const year = (new Date()).getFullYear();

        const getYear = () => {
            const yr = [];
            for(let i = year; i <= year + 15; i++) {
                yr.push(i);
            }

            return yr;
        }

        return (
            <div className="row">
                <div className="col-md-12 pull-right">
                    <h4>Billing Information</h4>
                    <img src={ CreditCardLogo } alt="presentation"/>
                    <br/>
                    <br/>
                </div>

                <div className="col-md-8">
                    <div className="form-group">
                        <label>Card Number</label>
                        <MaskInput name="cc" className="form-control form-custom" mask="9999-9999-9999-9999" onChange={this.onChange}/>
                    </div>
                </div>
                <div className="col-md-4">
                    <div className="form-group">
                        <label>CVV</label>
                        <input 
                            onChange={this.onChange}
                            type="text" 
                            name="cvv" 
                            className="form-control form-custom"/>
                    </div>
                </div>

                <div className="col-md-4">
                    <div className="form-group">
                        <label>Expiration Date</label>
                        <select onChange={this.onChange} name="exp_month" className="form-control form-custom">
                            <option value="">MONTH</option>
                            <option value="1">Jan</option>
                            <option value="2">Feb</option>
                            <option value="3">Mar</option>
                            <option value="4">Apr</option>
                            <option value="5">May</option>
                            <option value="6">Jun</option>
                            <option value="7">Jul</option>
                            <option value="8">Aug</option>
                            <option value="9">Sept</option>
                            <option value="10">Oct</option>
                            <option value="11">Nov</option>
                            <option value="12">Dec</option>
                        </select>
                    </div>
                </div>
                <div className="col-md-4">
                    <div className="form-group">
                        <label>&nbsp;</label>
                        <select onChange={this.onChange} name="exp_year" className="form-control form-custom">
                            <option value="">YEAR</option>
                            { getYear().map((year,index) => {
                                return (
                                    <option key={`year_${index}`} value={year}>{year}</option>
                                )
                            }) }
                        </select>
                    </div>
                </div>
                <div className="col-md-4">
                    <div className="form-group">
                        <label>Promo Code</label>
                        <input 
                            onChange={this.onChange}
                            type="text" 
                            name="promo_code" 
                            className="form-control form-custom"/>
                    </div>
                </div>
            </div>
        );
    }
}

export default CreditCardInfo



// WEBPACK FOOTER //
// ./src/billing/components/CreditCardInfo.js